import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import type { ToastType } from '@modules/shared/stores/toast'


export default /*@__PURE__*/_defineComponent({
  __name: 'ToastItem',
  props: {
    id: { type: Number, required: true },
    type: { type: String, required: true },
    message: { type: String, required: true },
    duration: { type: Number, required: true }
  },
  emits: ["dismiss"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props

const emit = __emit

const remaining = ref(props.duration)
const startedAt = ref(0)
const timer = ref<number | null>(null)

const iconName = computed(() => (props.type === 'success' ? 'mdi-check' : 'mdi-close'))

const dismiss = () => emit('dismiss', props.id)

const start = () => {
  if (remaining.value <= 0) return
  startedAt.value = Date.now()
  timer.value = window.setTimeout(dismiss, remaining.value)
}

const pause = () => {
  if (timer.value !== null) {
    clearTimeout(timer.value)
    timer.value = null
    remaining.value -= Date.now() - startedAt.value
  }
}

const resume = () => {
  if (timer.value === null) start()
}

onMounted(start)
onBeforeUnmount(() => {
  if (timer.value !== null) clearTimeout(timer.value)
})

const __returned__ = { props, emit, remaining, startedAt, timer, iconName, dismiss, start, pause, resume }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})